import { WidgetType } from 'domain/entity/widget';
import { WidgetTextDescription } from 'domain/entity/widgets/TextData';

export type BusinessInsightHighchartsOptions = Record<string, unknown>;

export type WidgetRichText = {
    type: WidgetType;
    description?: WidgetTextDescription;
    text: string;
    highcharts?: BusinessInsightHighchartsOptions;
};

export class WidgetRichTextContent {
    constructor(readonly text: string) {}
}

class RichTextData implements WidgetRichText {
    constructor(
        readonly text: string,
        public description?: WidgetTextDescription,
        readonly type: WidgetType = WidgetType.RICH_TEXT,
        readonly highcharts?: BusinessInsightHighchartsOptions
    ) {}
}

export default RichTextData;
